import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import tabbable from 'tabbable';

var FocusTrap = /*#__PURE__*/function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap() {
    var _this;

    _classCallCheck(this, FocusTrap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.returnFocusNode = void 0;

    _this.initiateTrap = function () {
      var element = document.activeElement;

      while (element && element !== _this.trapEl.current) {
        element = element.parentElement;
      }

      var isAlreadyInTrap = !!element;

      if (isAlreadyInTrap) {
        return;
      } // focusContainer means we want to always focus on the modal container,
      // even if there are interactive elements in the trap. This is useful when
      // it is undesirable to focus on the first interactive element, e.g. a tooltip


      if (_this.props.focusContainer) {
        _this.trapEl.current && _this.trapEl.current.focus();
        return;
      }

      _this.jumpFocus(0);
    };

    _this.getFocusableEls = function () {
      if (!_this.trapEl.current) {
        return [];
      }

      return tabbable(_this.trapEl.current);
    };

    _this.jumpFocus = function (index) {
      if (!_this.props.trapFocus) {
        return;
      }

      var focusableEls = _this.getFocusableEls(); // If there are no focusable elements in the trap, focus on the container


      if (!focusableEls.length) {
        _this.trapEl.current && _this.trapEl.current.focus();
        return;
      }

      var i = typeof index === 'function' ? index(focusableEls.length) : index;
      focusableEls[i] && focusableEls[i].focus();
    };

    _this.handleKeyDown = function (e) {
      if (!_this.props.trapFocus || !_this.trapEl.current || e.key !== 'Tab') {
        return;
      }

      e.preventDefault();

      var focusableEls = _this.getFocusableEls();

      var idx = focusableEls.indexOf(e.target); // In order to handle custom tabIndex values, we must actually hijack *all*
      // tab/shift+tab events in the trap. Otherwise, if we have one `tabIndex="1"` el in
      // a modal, native tab behavior would be to focus next on the first `tabIndex="0"`
      // (or equivalent) item in the entire document, which would likely move focus
      // outside. This lets us maintain the correct tab index ordering, but "scoped"
      // to within the trap.

      if (e.shiftKey) {
        // We want to tab to the "previous" item; if "previous" is out of bounds,
        // go to the last item
        _this.jumpFocus(function (numItems) {
          return idx - 1 < 0 ? numItems - 1 : idx - 1;
        });
      } else {
        // We want to tab to the "next" item; if "next" is out of bounds,
        // go to the first item
        _this.jumpFocus(function (numItems) {
          return idx + 1 >= numItems ? 0 : idx + 1;
        });
      }
    };

    _this.trapEl = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(FocusTrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.returnFocusNode = document.activeElement;
      this.initiateTrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.trapFocus && this.props.trapFocus) {
        this.initiateTrap();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.returnFocus && this.returnFocusNode && this.returnFocusNode.focus) {
        this.returnFocusNode.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className;
      return /*#__PURE__*/React.createElement("span", {
        className: className,
        tabIndex: "-1",
        ref: this.trapEl,
        onKeyDown: this.handleKeyDown
      }, children);
    }
  }]);

  return FocusTrap;
}(React.Component);

export default FocusTrap;